var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeviceAndTechnologySmsAlert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-3880.000000, -1107.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Device-and-technology/Sms-alert",
    transform: "translate(3880.000000, 1107.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.796,16.09 L11.549,7.216 L11.552,7.216 C11.906,6.05 12.748,5.086 13.849,4.531 C13.956,4.476 14.069,4.434 14.18,4.386 C14.247,4.359 14.312,4.326 14.38,4.302 C14.886,4.112 15.428,4 16,4 C16.571,4 17.114,4.112 17.619,4.302 C17.687,4.326 17.752,4.359 17.819,4.386 C17.93,4.434 18.044,4.476 18.15,4.531 C19.252,5.086 20.092,6.05 20.447,7.216 L20.45,7.216 L22.203,16.09 L9.796,16.09 Z M16,19.239 C14.851,19.239 13.921,18.302 13.9,17.14 L18.099,17.14 C18.079,18.302 17.148,19.239 16,19.239 L16,19.239 Z M4,0 C1.791,0 0,1.791 0,4 L0,23 L0.001,23 L0.001,32 L0.265,32 C1.93,32 3.004,31.051 4.078,29.374 L7.933,23 L9.696,23 L28,23 C30.209,23 32,21.209 32,19 L32,0 L4,0 Z",
    id: 136
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceAndTechnologySmsAlert);
export default __webpack_public_path__ + "static/media/device-and-technology-sms-alert.d30c2ec7.svg";
export { ForwardRef as ReactComponent };